import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import type { RefObject } from 'react';
import { forwardRef } from 'react';

import type { HeroCarouselProps } from '../HeroCarousel';
import HeroCarousel from '../HeroCarousel';

interface CarouselProductLayoutProps {
  readonly carouselRef: RefObject<HTMLDivElement | null>;
  readonly carouselProps: HeroCarouselProps;
  readonly children: React.ReactNode;
}

const CarouselProductLayout = forwardRef<
  HTMLDivElement,
  CarouselProductLayoutProps
>(({ carouselRef, carouselProps, children }, ref) => {
  return (
    <div ref={ref} data-cy="carousel-product-layout">
      <LayoutGrid rowGap={0}>
        <GridItem
          colEnd={{ sm: 'full', lg: 15, xl: 17 }}
          colStart={{ sm: 'full' }}
          rowStart={{ sm: 1 }}
        >
          <div className="size-full" data-cy="carousel-wrapper">
            <div
              className="sticky top-0 w-full flex-1 lg:top-24"
              ref={carouselRef}
              data-cy="hero-carousel-container"
            >
              <HeroCarousel {...carouselProps} />
            </div>
          </div>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'full' }}
          colStart={{ sm: 'full' }}
          rowStart={{ sm: 1 }}
        >
          <LayoutGrid className="max-lg:relative max-lg:z-10 max-lg:mt-[calc(70svh_-_2rem)] max-lg:rounded-t-4xl max-lg:bg-sandstone-200 max-lg:pt-6 lg:min-h-full">
            <GridItem
              colEnd={{ sm: 'main' }}
              colStart={{ sm: 'main', lg: 16, xl: 18 }}
            >
              <section
                className="mt-4 lg:mt-0"
                data-cy="carousel-product-content"
              >
                {children}
              </section>
            </GridItem>
          </LayoutGrid>
        </GridItem>
      </LayoutGrid>
    </div>
  );
});

CarouselProductLayout.displayName = 'CarouselProductLayout';

export default CarouselProductLayout;
